import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "toast-stack" };
const _hoisted_2 = { class: "toast-message" };
const _hoisted_3 = ["onClick"];
import { computed } from 'vue';
import { useToastStore } from '@/stores/toastStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ToastStack',
    setup(__props) {
        const store = useToastStore();
        const toasts = computed(() => store.toasts);
        const dismiss = (id) => store.dismiss(id);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toasts.value, (t) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: t.id,
                        class: _normalizeClass(['toast', 'toast-' + t.type])
                    }, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(t.message), 1),
                        _createElementVNode("button", {
                            class: "toast-close",
                            onClick: ($event) => (dismiss(t.id))
                        }, "✕", 8, _hoisted_3)
                    ], 2));
                }), 128))
            ]));
        };
    }
});
